import { IUserType } from '@/modules/user-type/models';

export interface State {
    userTypes: IUserType[];
    userTypeSelected: IUserType;
    showRegisterForm: boolean;
}

export const state = (): State => ({
    userTypes: [],
    showRegisterForm: false,
    userTypeSelected: {
        id: 0,
        usertypename: '',
        isactive: true,
    },
});
